// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2864": "da76a8b9db58","3826": "0129ab72d18c","6863": "454c9f289029","6887": "85dfe66612ea","8561": "f9cad78a6d35","8990": "7d69c8cdd354",}[chunkId] + ".css"
}